import React from 'react';
import { ShieldCheck, Lock, AlertOctagon, LineChart } from 'lucide-react';
import { FeaturePreview } from './FeaturePreview';

/**
 * Feature preview component for Security Center feature
 * Displays information about the Security Center feature and its benefits
 */
export const SecurityCenterFeaturePreview: React.FC = () => {
  return (
    <FeaturePreview
      title="Security Center"
      description="Get a comprehensive view of your organization's security posture with centralized monitoring, analytics, and remediation recommendations."
      icon={<ShieldCheck className="h-8 w-8 text-blue-600" />}
      featureName="security-center"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        {/* Feature Card 1 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <ShieldCheck className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Dashboard</h3>
          </div>
          <p className="text-gray-400">
            Unified dashboard providing a holistic view of your security posture across all assets and attack vectors.
          </p>
        </div>

        {/* Feature Card 2 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <AlertOctagon className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Risk Assessment</h3>
          </div>
          <p className="text-gray-400">
            Comprehensive risk assessment with prioritized security recommendations to improve your security posture.
          </p>
        </div>

        {/* Feature Card 3 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <LineChart className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Security Metrics</h3>
          </div>
          <p className="text-gray-400">
            Track key security metrics and trends over time to measure the effectiveness of your security program.
          </p>
        </div>

        {/* Feature Card 4 */}
        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700 hover:border-blue-500 transition-colors">
          <div className="flex items-center mb-4">
            <Lock className="h-6 w-6 text-blue-500 mr-3" />
            <h3 className="text-lg font-medium text-white">Compliance Monitoring</h3>
          </div>
          <p className="text-gray-400">
            Monitor compliance with security standards and regulations with automated checks and reporting.
          </p>
        </div>
      </div>
    </FeaturePreview>
  );
};
